<template>
    <div class="partner-tier-chart bg-white p-5 shadow-md rounded-xl h-full">
        <h2 class="text-lg font-semibold text-gray-700 mb-3 flex items-center">
            <span class="partner-tier-chart-icon mr-2">🏆</span>
            <span>Partners by Tier</span>
        </h2>
        <div v-if="hasData" class="chart-container">
            <apexchart
                type="bar"
                height="260"
                :options="chartOptions"
                :series="chartSeries"
                @dataPointSelection="onBarSelect"
            />
        </div>
        <div v-else class="chart-empty">
            <span class="chart-empty-icon">📊</span>
            <p class="chart-empty-text">No tier data available</p>
        </div>
    </div>
</template>

<script>
import { TIER_DISPLAY_ORDER } from "../../../helpers/partnerTier";

export default {
    name: "PartnersByTierChart",
    props: {
        data: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    computed: {
        orderedData() {
            if (!this.data || this.data.length === 0) {
                return [];
            }

            var dataByTier = {};
            for (var i = 0; i < this.data.length; i++) {
                var item = this.data[i];
                if (item && item.tier) {
                    dataByTier[item.tier] = item;
                }
            }

            var ordered = [];
            for (var j = 0; j < TIER_DISPLAY_ORDER.length; j++) {
                var tier = TIER_DISPLAY_ORDER[j];
                if (dataByTier[tier]) {
                    ordered.push(dataByTier[tier]);
                }
            }

            return ordered;
        },
        hasData() {
            return this.orderedData.length > 0;
        },
        chartOptions() {
            return {
                chart: {
                    type: "bar",
                    toolbar: { show: false },
                },
                xaxis: {
                    categories: this.orderedData.map(function (item) {
                        return item.tier;
                    }),
                    title: {
                        text: "Tier",
                        style: {
                            fontSize: "12px",
                            fontWeight: "bold",
                        },
                    },
                },
                yaxis: {
                    title: {
                        text: "Number of Partners",
                        style: {
                            fontSize: "12px",
                            fontWeight: "bold",
                        },
                    },
                    min: 0,
                    forceNiceScale: true,
                },
                colors: this.getTierColors(),
                plotOptions: {
                    bar: {
                        borderRadius: 8,
                        borderRadiusApplication: "end",
                        columnWidth: "55%",
                        distributed: true,
                        dataLabels: {
                            position: "center",
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                    offsetY: 0,
                    style: {
                        fontSize: "13px",
                        fontWeight: 700,
                        colors: ["#ffffff"],
                    },
                    formatter: function (val) {
                        return val;
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " partner" + (val === 1 ? "" : "s");
                        },
                    },
                },
                legend: {
                    show: false,
                },
                grid: {
                    borderColor: "#e2e8f0",
                    strokeDashArray: 4,
                },
            };
        },
        chartSeries() {
            return [
                {
                    name: "Partners",
                    data: this.orderedData.map(function (item) {
                        return item.count;
                    }),
                },
            ];
        },
    },
    methods: {
        onBarSelect: function (event, chartContext, config) {
            var selectedTier = chartContext.w.config.xaxis.categories[config.dataPointIndex];
            if (selectedTier) {
                this.onTierBarClick(selectedTier);
            }
        },
        onTierBarClick(tier) {
            this.$emit("tier-clicked", tier);
        },
        getTierColors() {
            return ["#7c3aed", "#2563eb", "#d97706", "#64748b"];
        },
    },
};
</script>

<style scoped>
.partner-tier-chart {
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.partner-tier-chart-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 9999px;
    background: linear-gradient(135deg, #ede9fe 0%, #dbeafe 100%);
}

.chart-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 320px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px dashed #cbd5e1;
}

.chart-empty-icon {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
    opacity: 0.6;
}

.chart-empty-text {
    font-size: 0.9375rem;
    color: #64748b;
}
</style>
